import { getScribeHttpClients } from '@heidi/api/client';
import type {
  EvidenceSBSConfirmResponse,
  EvidenceSBSSetupResponse,
  EvidenceSBSSkipResponse,
  EvidenceTriggerLocation,
} from '@heidi/evidence/contracts';

export interface EvidenceSBSSetupRequest {
  chat_id: string;
  message_index: number;
  session_id?: string | null;
  evidence_trigger_location: EvidenceTriggerLocation;
  country?: string | null;
  region?: string | null;
}

export interface EvidenceSBSConfirmRequest {
  chat_id: string;
  selected_candidate_id: string;
  displayed_at?: string | null;
  selected_at?: string | null;
}

export interface EvidenceSBSSkipRequest {
  chat_id: string;
  candidate_id: string;
  displayed_at?: string | null;
  skipped_at?: string | null;
}

export const postEvidenceSBSSetup = async (body: EvidenceSBSSetupRequest) => {
  const resp = await getScribeHttpClients().scribeHttpV2.post<EvidenceSBSSetupResponse>(
    '/chat/sbs/setup',
    body
  );
  return resp;
};

export const postEvidenceSBSConfirm = async (body: EvidenceSBSConfirmRequest) => {
  const resp = await getScribeHttpClients().scribeHttpV2.post<EvidenceSBSConfirmResponse>(
    '/chat/sbs/confirm',
    body
  );
  return resp;
};

export const postEvidenceSBSSkip = async (body: EvidenceSBSSkipRequest) => {
  const resp = await getScribeHttpClients().scribeHttpV2.post<EvidenceSBSSkipResponse>(
    '/chat/sbs/skip',
    body
  );
  return resp;
};
